module.exports = __webpack_public_path__ + "static/media/2 - cout avantageux.f52a1691.png";